import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LIMIT, MAX_SIZE } from '../../../utils/constants';
import { ICONS } from '../../../utils/svg-icons';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { SafeHtmlPipe } from '../../validators/safe-html.pipe';
import { CommentBoxComponent } from '../comment-box/comment-box.component';

@Component({
  selector: 'app-comment-feed',
  imports: [CommentBoxComponent, CommonModule, SafeHtmlPipe],
  templateUrl: './comment-feed.component.html',
  styleUrl: './comment-feed.component.scss',
  providers: [NgbActiveModal],
})
export class CommentFeedComponent {
  commentCounts = 0;
  @Input() public DetailsFeed: any;
  @Input() public page: any;
  pagination = { limit: LIMIT, maxSize: MAX_SIZE, skip: 0, totalItems: 0, row: 0, text: 'Loading...' };
  reload = false;
  activeModal = inject(NgbActiveModal);
  ICONS = ICONS;

  constructor(
    public activeOffcanvas: NgbActiveOffcanvas,
    private _activeModal: NgbActiveModal,
    private _commonDataService: CommonDataSharingService,
  ) {}

  ngAfterViewInit() {
    this.postCount();
  }

  onClose() {
    this.activeOffcanvas.close();
  }

  postCount() {
    let array: any = [this.DetailsFeed.id];
    const mutation = `query getPostsCounts {
        getPostsCounts(postIds: ${JSON.stringify(array)}) {
            items {
            commentCount
            likeCount
            postId
          }
        }
      }`;
    this._commonDataService.graphqlApiCall(mutation).then((res) => {
      this.commentCounts = res?.data?.getPostsCounts?.items[0]?.commentCount;
    });
  }
}
